<template>
  <div class="container-fluid m-0 p-0">
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Document List</span>
        <span class="mx-3">
          <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                  data-toggle="modal"
                  data-target="#add-document"
          >
            <span class="fas fa-plus"></span>
            Add Document
          </button>
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>

    <div class="row text-small pt-3">
      <div class="col col-md-12" style="min-height: 450px !important;">
        <div class="form-group form-inline">
          <label for="search-document" class="pr-3 font-weight-bold">Search Document Here: </label>
          <input class="form-control form-control-sm mr-2 w-25" id="search-document" style=""
                 type="text" placeholder="Input Any Here . . ."
                 v-model="searchValue"
                 @input="setPage(1)"
          >
          <button type="button" class="btn btn-primary btn-sm"
                  @click="searchValue = ''; setPage(1)"
          >CLEAR</button>

          <label for="document-type-search" class="pr-3 font-weight-bold ml-5">Document Type: </label>
          <select id="document-type-search" class="form-control form-control-xs input-group-append"
                  v-model="documentTypeId"
                  @change="setPage(0)"
          >
            <option :value="null">--- All Document Types ---</option>
            <option v-for="documentTypeKey in documentTypeKeys"
                    :key="documentTypeKey.id"
                    :value="documentTypeKey.id"
            >{{ documentTypeKey.name }}</option>
          </select>

          <label for="document-status-search" class="pr-3 font-weight-bold ml-5">Document Status: </label>
          <select id="document-status-search" class="form-control form-control-xs input-group-append"
                  v-model="documentStatus"
                  @change="setPage(0)"
          >
            <option :value="''">--- ALL ---</option>
            <option :value="1">ACTIVE</option>
            <option :value="0">INACTIVE</option>
          </select>

        </div>
        <div class="table-responsive text-small" style="height: 475px;">
          <table  class="table table-hover table-bordered table-template-1 text-small sticky-header">
            <thead>
            <tr>
              <th>#</th>
              <th class="col-name">PORT CODE</th>
              <th>DOCUMENT NAME</th>
              <th>DOCUMENT TYPE</th>
              <th>FLAG</th>
              <th>STATUS</th>
              <th class="col-actions">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(document, index) in documents" :key="document.id" :class="{ inactive: !document.active }">
              <td>{{ index + pagination.from }}</td>
              <td>{{ document.code }}</td>
              <td>{{ document.name }}</td>
              <td>{{ document.documentTypeName }}</td>
              <td>{{ document.flag }}</td>
              <td>{{ document.active ? 'ACTIVE' : 'INACTIVE' }}</td>
              <td class="text-center col-actions">
                <button class="btn btn-sm btn-xs btn-warning font-weight-bolder mr-1 ml-auto"
                        data-toggle="modal"
                        data-target="#edit-document"
                        @click="viewDocument(document)"
                >
                  <span class="fas fa-edit"></span>
                  Edit
                </button>
  <!--              <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"-->
  <!--                      @click="confirmDeletePort(document)"-->
  <!--              >-->
  <!--                <span class="fas fa-trash-alt"></span>-->
  <!--                Delete-->
  <!--              </button>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>


      </div>

      <nav aria-label="..." class="ml-3 pt-2">
        <ul class="pagination text-smallest">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>

    </div>

    <app-modal unique="edit-document" title="EDIT DOCUMENT DETAILS" size="lg">

      <form @submit.prevent="confirmUpdateDocument">
        <div class="form-group form-row mb-1" :class="{'has-error': editDocumentErrors.code }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="document-code" >
            Document Code:
          </label>
          <div class="col col-sm-7">
            <input type="text" id="document-code"
                   class="form-control form-control-xs"
                   placeholder="DOCUMENT CODE NOT SPECIFIED"
                   v-model="editDocument.code"
            >
            <span class="help-block" v-if="editDocumentErrors.code !== ''">
                <small><strong>{{ editDocumentErrors.code }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editDocumentErrors.name }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="document-name" >
            Document Name:
          </label>

          <div class="col col-sm-7">
            <input type="text" id="document-name"
                   class="form-control form-control-xs"
                   placeholder="DOCUMENT NAME NOT SPECIFIED"
                   v-model="editDocument.name"
            >
            <span class="help-block" v-if="editDocumentErrors.name !== ''">
                <small><strong>{{ editDocumentErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editDocumentErrors.document_type_id }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="document-type" >
            Document Type:
          </label>

          <div class="col col-sm-7">
            <select id="document-type" class="form-control form-control-xs input-group-append"
                    v-model="editDocument.document_type_id"
            >
              <option :value="null">--- No Document Type ---</option>
              <option v-for="documentTypeKey in documentTypeKeys"
                      :key="documentTypeKey.id"
                      :value="documentTypeKey.id"
              >{{ documentTypeKey.name }}</option>
            </select>
            <span class="help-block" v-if="editDocumentErrors.document_type_id !== ''">
                <small><strong>{{ editDocumentErrors.document_type_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editDocumentErrors.country_id }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="document-country" >
            Flag Requirement:
          </label>

          <div class="col col-sm-7">
            <select id="document-country" class="form-control form-control-xs input-group-append"
                    v-model="editDocument.country_id"
            >
              <option :value="undefined">--- No Flag Requirement ---</option>
              <option v-for="flagRequirement in flagRequirements"
                      :key="flagRequirement.id"
                      :value="flagRequirement.id"
              >{{ flagRequirement.name }}</option>
            </select>
            <span class="help-block" v-if="editDocumentErrors.country_id !== ''">
                <small><strong>{{ editDocumentErrors.country_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editDocumentErrors.active }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="document-status" >
            Status:
          </label>

          <div class="col col-sm-7">
            <div class="form-check d-block">
              <input class="form-check-input" type="checkbox"
                     id="document-status"
                     v-model="editDocument.active"
              >
              <label class="form-check-label w-100 text-left"
                     for="document-status"
              >
                {{ editDocument.active | status }}
              </label>
            </div>
            <span class="help-block" v-if="editDocumentErrors.active !== ''">
                <small><strong>{{ editDocumentErrors.active }}</strong></small>
            </span>
          </div>
        </div>
        <hr style="border-color: #E0DED7"/>
        <h5 class="text-left font-weight-bold">Document Form Fields</h5>
        <div class="form">
          <div class="form-group form-row mb-1">
            <label class="col col-4 col-form-label font-weight-bolder text-right" for="document_no_field" >
              Doc No:
            </label>

            <div class="col col-7">
              <div class="form-check d-block float-left">
                <input class="form-check-input" type="checkbox"
                       id="document_no_field"
                       v-model="editDocument.doc_no"
                >
                <label class="form-check-label w-100 text-left"
                       for="document_no_field"
                >
                  {{ editDocument.doc_no | isRequired }}
                </label>
              </div>
            </div>
          </div>
          <div class="form-row justify-content-center mb-2 p" v-if="editDocument.doc_no">
            <div class="col-5 border" >
              <p class="text-small font-weight-bold">DOC NO. Additional Requirements</p>
              <div class="form-group">
                <label for="Character Type" class="form-label mr-2">Char. Type:</label>
                <select v-model="editDocument.charType">
                  <option :value="null">NOT APPLICABLE</option>
                  <option value="ALPHA">ALPHA</option>
                  <option value="NUMERIC">NUMERIC</option>
                  <option value="BOTH">ALPHA NUMERIC</option>
                </select>
              </div>
              <div class="form-group" v-if="editDocument.charType">
                <label for="Character Type" class="form-label mr-2">Length:</label>
                <select v-model="editDocument.lengthType">
                  <option :value="null">NOT APPLICABLE</option>
                  <option value="LENGTH">BY LENGTH</option>
                  <option value="RANGE">WITHIN RANGE</option>
                </select>
              </div>
              <div class="form-group" v-if="this.editDocument.lengthType==='RANGE' && editDocument.charType">
                <div>
                  <label for="min" class="mr-2">Min</label>
                  <input type="number" id="min" name="min" placeholder="min" v-model="editDocument.min">
                </div>
                <div>
                  <label for="max" class="mr-2">Max</label>
                  <input type="number" id="max" name="max" placeholder="max" v-model="editDocument.max">
                </div>
              </div>
              <div class="form-group" v-else-if="this.editDocument.lengthType==='LENGTH' && editDocument.charType">
                <label for="length" class="mr-2">Length</label>
                <input type="number" id="length" name="length" placeholder="length" v-model="editDocument.length">
              </div>
            </div>
          </div>
          <div class="form-group form-row mb-1">
            <label class="col col-4 col-form-label font-weight-bolder text-right" for="issued_date_field" >
              Issued Date:
            </label>
            <div class="col col-7">
              <div class="form-check d-block float-left">
                <input class="form-check-input" type="checkbox"
                       id="issued_date_field"   v-model="editDocument.issued_date"
                >
                <label class="form-check-label w-100 text-left"
                       for="issued_date_field"
                >
                  {{ editDocument.issued_date | isRequired }}
                </label>
              </div>
            </div>
          </div>
          <div class="form-group form-row mb-1">
            <label class="col col-4 col-form-label font-weight-bolder text-right" for="expiry_date_field" >
              Expiry Date:
            </label>
            <div class="col col-7">
              <div class="form-check d-block float-left">
                <input class="form-check-input" type="checkbox"
                       id="expiry_date_field"  v-model="editDocument.expiry_date"
                >
                <label class="form-check-label w-100 text-left"
                       for="expiry_date_field"
                >
                  {{ editDocument.expiry_date | isRequired }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <hr style="border-color: #E0DED7"/>
        <h5 class="text-left font-weight-bold">Document Matrix</h5>
        <div class=" table-responsive text-small" style="height: 330px;">
          <table class="table table-hover table-template-1 my-2 text-small sticky-header" v-if="editDocument.documentMatrix">
            <thead>
            <tr>
              <th></th>
              <th v-for="countryKey in countryKeys" :key="countryKey.id"
                  :title="countryKey.name"
                  :class="{ 'bg-primary' : hoveredCountryId === countryKey.id}"
                  @click="updateExistingMatrix(null, countryKey.id)"
              >
                {{ countryKey.natl_code }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="rankKey in rankKeys" :key="rankKey.id">
              <td :title="rankKey.name" class="font-weight-bold"
                  @click="updateExistingMatrix(rankKey.id, null)"
              >{{ rankKey.alias }}</td>
              <td v-for="countryKey in countryKeys" :key="countryKey.id"
                  class="text-center align-middle"
                  @mouseover="hoveredCountryId = countryKey.id"
                  @mouseleave="hoveredCountryId = null"
              >
                <input class="form-control form-control-sm form-control-xs" type="checkbox"
                       :id="`check-${rankKey.id}-${countryKey.id}`"
                       :checked="editDocument.documentMatrix.some(matrix => matrix.rank_id === rankKey.id && matrix.country_id === countryKey.id)"
                       @click="updateMatrixSelection(rankKey.id, countryKey.id)"
                >
              </td>
            </tr>
            </tbody>
          </table>
        </div>


        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-warning font-weight-bolder float-right">
          <span class="fas fa-edit"></span>
          Update
        </button>

      </form>
    </app-modal>

    <app-modal unique="add-document" title="ADD DOCUMENT" size="lg">

      <form @submit.prevent="confirmAddDocument">
        <div class="form-group form-row mb-1" :class="{'has-error': newDocumentErrors.code }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="add-document-code" >
            Document Code:
          </label>
          <div class="col col-sm-7">
            <input type="text" id="add-document-code"
                   class="form-control form-control-xs"
                   placeholder="ENTER DOCUMENT CODE HERE"
                   v-model="newDocument.code"
            >
            <span class="help-block" v-if="newDocumentErrors.code !== ''">
                <small><strong>{{ newDocumentErrors.code }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newDocumentErrors.name }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="add-document-name" >
            Document Name:
          </label>

          <div class="col col-sm-7">
            <input type="text" id="add-document-name"
                   class="form-control form-control-xs"
                   placeholder="ENTER DOCUMENT NAME HERE"
                   v-model="newDocument.name"
            >
            <span class="help-block" v-if="newDocumentErrors.name !== ''">
                <small><strong>{{ newDocumentErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newDocumentErrors.document_type_id }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="add-document-type" >
            Document Type:
          </label>

          <div class="col col-sm-7">
            <select id="add-document-type" class="form-control form-control-xs input-group-append"
                    v-model="newDocument.document_type_id"
            >
              <option :value="undefined">--- No Document Type ---</option>
              <option v-for="documentTypeKey in documentTypeKeys"
                      :key="documentTypeKey.id"
                      :value="documentTypeKey.id"
              >{{ documentTypeKey.name }}</option>
            </select>
            <span class="help-block" v-if="newDocumentErrors.document_type_id !== ''">
                <small><strong>{{ newDocumentErrors.document_type_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newDocumentErrors.country_id }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="add-document-country" >
            Flag Requirement:
          </label>

          <div class="col col-sm-7">
            <select id="add-document-country" class="form-control form-control-xs input-group-append"
                    v-model="newDocument.country_id"
            >
              <option :value="undefined">--- No Flag Requirement ---</option>
              <option v-for="flagRequirement in flagRequirements"
                      :key="flagRequirement.id"
                      :value="flagRequirement.id"
              >{{ flagRequirement.name }}</option>
            </select>
            <span class="help-block" v-if="newDocumentErrors.country_id !== ''">
                <small><strong>{{ newDocumentErrors.country_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newDocumentErrors.active }">
          <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-document-status" >
            Status:
          </label>

          <div class="col col-sm-7">
            <div class="form-check d-block">
              <input class="form-check-input" type="checkbox"
                     id="new-document-status"
                     v-model="newDocument.active"
              >
              <label class="form-check-label w-100 text-left"
                     for="new-document-status"
              >
                {{ newDocument.active | status }}
              </label>
            </div>
            <span class="help-block" v-if="newDocumentErrors.active !== ''">
                <small><strong>{{ newDocumentErrors.active }}</strong></small>
            </span>
          </div>
        </div>
        <hr style="border-color: #E0DED7"/>

        <h5 class="text-left font-weight-bold">Document Matrix</h5>

        <div class=" table-responsive text-small" style="height: 330px;">
          <table class="table table-hover table-template-1 my-2 text-small sticky-header">
            <thead>
            <tr>
              <th></th>
              <th v-for="countryKey in countryKeys" :key="countryKey.id"
                  :title="countryKey.name"
                  :class="{ 'bg-primary' : hoveredCountryId === countryKey.id}"
                  @click="updateNewMatrix(null, countryKey.id)"
              >
                {{ countryKey.natl_code }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="rankKey in rankKeys" :key="rankKey.id">
              <td :title="rankKey.name" class="font-weight-bold"
                  @click="updateNewMatrix(rankKey.id, null)"
              >{{ rankKey.alias }}</td>
              <td v-for="countryKey in countryKeys" :key="countryKey.id"
                  class="text-center align-middle"
                  @mouseover="hoveredCountryId = countryKey.id"
                  @mouseleave="hoveredCountryId = null"
              >
                <input class="form-control form-control-sm form-control-xs" type="checkbox"
                       :id="`new-check-${rankKey.id}-${countryKey.id}`"
                       :checked="newDocumentMatrix.some(matrix => matrix.rank_id === rankKey.id && matrix.country_id === countryKey.id)"
                       @click="updateNewMatrixSelection(rankKey.id, countryKey.id)"
                >
              </td>
            </tr>
            </tbody>
          </table>
        </div>


        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-warning font-weight-bolder float-right">
          <span class="fas fa-edit"></span>
          Update
        </button>

      </form>
    </app-modal>

  </div>
</template>

<script>

import AppModal from "@/components/elements/AppModal";

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

export default {
  name: "DocumentIndex",

  mixins: [ vueAppMixin, paginationMixin ],

  components: { AppModal },
  data() {
    return {
      searchValue: '',
      documentTypeId: null,
      documentStatus: '',
      editDocument: {},
      editDocumentErrors: {},
      newDocument: {},
      newDocumentMatrix: [],
      newDocumentErrors: {},
      hoveredCountryId: null,
      flagRequirements: [],
    }
  },

  methods: {
    ...mapActions([
        'getDocuments',
        'getDocumentTypeKeys',
        'updateDocument',
        'getCountryKeys',
        'getRankKeys',
        'addDocument'
    ]),

    async initializeData() {
      this.flagRequirements = Object.assign([], await this.getCountryKeys());
      this.getDocuments({});
      this.getDocumentTypeKeys();
      this.getRankKeys();
      this.getCountryKeys({ isManning: true });
    },

    searchDocument() {
      let page = this.pagination.currentPage;
      let params = {
        page: page,
        searchValue: this.searchValue,
        documentTypeId: this.documentTypeId,
      };
      if(this.documentStatus !== '') params['documentStatus'] = this.documentStatus;
      this.getDocuments(params);
    },

    setPage(page) {
      this.pagination.currentPage = page;
      this.searchDocument();
    },

    viewDocument(document) {
      this.editDocument = Object.assign({}, document);
      this.editDocumentErrors = {};
    },

    async confirmUpdateDocument() {
      if(await this.confirmUpdate()) {
        let params = {
          id: this.editDocument.id,
          code: this.editDocument.code,
          name: this.editDocument.name,
          active: this.editDocument.active,
          document_type_id: this.editDocument.document_type_id,
          country_id: this.editDocument.country_id,
          documentMatrix: this.editDocument.documentMatrix,
          doc_no:this.editDocument.doc_no,
          issued_date:this.editDocument.issued_date,
          expiry_date:this.editDocument.expiry_date,
          charType:this.editDocument.charType,
          lengthType:this.editDocument.lengthType,
          min:this.editDocument.min,
          max:this.editDocument.max,
          length:this.editDocument.length
        };
        let updatedDocument = await this.updateDocument(params);
        if(updatedDocument) {
          if(updatedDocument.errors) {
            this.editDocumentErrors = updatedDocument.errors;
          } else {
            this.successAlert('Document Successfully Updated', 'UPDATE');
            this.editDocument = {};
            this.editDocumentErrors = {};
            document.getElementById('close-edit-document').click();
          }
        }
      }
    },

    updateMatrixSelection(rankKeyId, countryKeyId) {
      if(document.getElementById(`check-${rankKeyId}-${countryKeyId}`).checked) {
        this.editDocument.documentMatrix.push({ rank_id: rankKeyId, country_id: countryKeyId });
      } else {
        this.editDocument.documentMatrix = this.editDocument.documentMatrix
            .filter(matrix =>  {
              return !(matrix.rank_id === rankKeyId && matrix.country_id === countryKeyId);
            });
      }
    },

    updateNewMatrixSelection(rankKeyId, countryKeyId) {
      if(document.getElementById(`new-check-${rankKeyId}-${countryKeyId}`).checked) {
        this.newDocumentMatrix.push({ rank_id: rankKeyId, country_id: countryKeyId });
      } else {
        this.newDocumentMatrix = this.newDocumentMatrix
            .filter(matrix =>  {
              return !(matrix.rank_id === rankKeyId && matrix.country_id === countryKeyId);
            });
      }
    },

    async confirmAddDocument() {
      if(await this.confirmCreateAlert()) {
        let params = {
          code: this.newDocument.code,
          name: this.newDocument.name,
          active: this.newDocument.active,
          document_type_id: this.newDocument.document_type_id,
          country_id: this.newDocument.country_id,
          documentMatrix: this.newDocumentMatrix
        };
        let newDocument = await this.addDocument(params);
        if(newDocument) {
          if(newDocument.errors) {
            this.newDocumentErrors = newDocument.errors;
          } else {
            this.successAlert('Document Successfully Added', 'CREATE');
            this.newDocument = {};
            this.newDocumentErrors = {};
            document.getElementById('close-add-document').click();
          }
        }
      }
    },

    updateNewMatrix(rankId, countryId) {
      this.newDocumentMatrix = this.updateMatrix(this.newDocumentMatrix, rankId, countryId);
    },

    updateExistingMatrix(rankId, countryId) {
      this.editDocument.documentMatrix = this.updateMatrix(this.editDocument.documentMatrix, rankId, countryId);
    },

    updateMatrix(updatingMatrix, rankId, countryId) {
      if(rankId) {
        let allSelected = true;
        this.countryKeys.forEach(countryKey => {
          if(!updatingMatrix.some(umatrix => umatrix.rank_id === rankId && umatrix.country_id === countryKey.id)) {
            allSelected = false;
          }
        });
        if(allSelected) {
          return updatingMatrix.filter(matrix => matrix.rank_id !== rankId);
        } else {
          this.countryKeys.forEach(countryKey => {
            if(!updatingMatrix.some(umatrix => umatrix.rank_id === rankId && umatrix.country_id === countryKey.id)) {
              let matrix = { rank_id: rankId, country_id: countryKey.id };
              updatingMatrix.push(matrix);
            }
          });
          return updatingMatrix;
        }
      } else if (countryId) {
        let allSelected = true;
        this.rankKeys.forEach(rankKey => {
          if(!updatingMatrix.some(umatrix => umatrix.country_id === countryId && umatrix.rank_id === rankKey.id)) {
            allSelected = false;
          }
        });
        if(allSelected) {
          return updatingMatrix.filter(matrix => matrix.country_id !== countryId);
        } else {
          this.rankKeys.forEach(rankKey => {
            if(!updatingMatrix.some(umatrix => umatrix.rank_id === rankKey.id && umatrix.country_id === countryId)) {
              let matrix = { rank_id: rankKey.id, country_id: countryId };
              updatingMatrix.push(matrix);
            }
          });
          return updatingMatrix;
        }
        // return updatingMatrix;
      }

    // :checked="newDocumentMatrix.some(matrix => matrix.rank_id === rankKey.id && matrix.country_id === countryKey.id)"

      // if(document.getElementById(`new-check-${rankKeyId}-${countryKeyId}`).checked) {
      //   this.newDocumentMatrix.push({ rank_id: rankKeyId, country_id: countryKeyId });
      // } else {
      //   this.newDocumentMatrix = this.newDocumentMatrix
      //       .filter(matrix =>  {
      //         return !(matrix.rank_id === rankKeyId && matrix.country_id === countryKeyId);
      //       });
      // }
    }

  },

  computed: {
    ...mapGetters([
        'documents',
        'documentTypeKeys',
        'countryKeys',
        'rankKeys'
    ]),
  },

  created() {
    this.initializeData();
  },
}
</script>

<style scoped>
/*th {*/
/*  background: lightgray;*/
/*  position: sticky;*/
/*  top: 0;*/
/*}*/
</style>